import Helper from '@ember/component/helper';

export function conversionTypeText([conversionType]) {
  if (conversionType === 'exit') {
    return 'leave';
  } else if (conversionType === 'perform_event') {
    return 'perform';
  } else {
    return conversionType;
  }
}

/*
  Basic Usage:

  ```handlebars
  {{conversion-type-text conversionType}}
  ```
*/
export default Helper.helper(conversionTypeText);
